import { Query } from '../Model/Query';
import { RegisterExternalBackground } from '../Model/RegisterExternalBackground';
export class RecordsExternalBackgroundService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findRegisters(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`register_external_antecedents?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los registros de antecedentes externos.`);
            }
            const content = await response.json();
            return content.map(diligence => new RegisterExternalBackground(diligence).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async find() {
        const response = await this.apiService.get('register_external_antecedents');
        if (!response.ok) {
            throw new Error(`Error al obtener antecedentes.`);
        }
        const content = await response.json();
        return content.map(antecedent => new RegisterExternalBackground(antecedent).getState());
    }
    async saveRegisters(register) {
        const response = await this.apiService.post('register_external_antecedents', register);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de antecedentes.`);
        }
        return true;
    }
    async getRecordsByThird(third_id) {
        const response = await this.apiService.get('registers_external_antecedents/' + third_id);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de antecedentes externos.`);
        }
        const content = await response.json();
        return content.map(register => new RegisterExternalBackground(register).getState());
    }
    async getRecordsQuantity(opts) {
        var _a;
        const query = new Query();
        if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
            query.addFilter('search', [opts.filters.search]);
        }
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`registers_external_antecedents_quantity?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener los antecedentes externos.`);
        }
        const content = await response.json();
        return parseInt(content);
    }
}
